/* eslint-disable react/display-name */

import React, { useState, useEffect } from "react";
import SubMainLayoutHelper from "layouts/helpers/SubMainLayoutHelper";
import PAGE_CODES from "themes/register/PageCodes";
import pages from "themes/cashrent/pages/register";
import { GetSiteConfigs } from "../hooks/useChangeGlobalStyles";
import RealTimeBidsContextProvider from "../context/real-time-bids.context";

const ROOT = "";

const Page = (props) => {
  const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);
  const SiteConfigs = GetSiteConfigs() || null;

  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setWindowInnerWidth(window.innerWidth);
  };

  const Component = pages[props.pageCode];

  return (
    <Component
      {...props}
      SiteConfigs={SiteConfigs}
      windowInnerWidth={windowInnerWidth}
    />
  );
};

export default [
  {
    path: `${ROOT}/cashrent-estimate/:id`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.CASHRENT_ESTIMATE} />
    ),
  },
  {
    path: `${ROOT}/admin`,
    authenticated: true,
    component: SubMainLayoutHelper,
    routes: [
      {
        path: `${ROOT}/admin/listings`,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_SEARCH_LISTING} />
        ),
      },
      {
        path: `${ROOT}/admin/listings/:userId`,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_SEARCH_LISTING} />
        ),
      },
      {
        path: `${ROOT}/admin/estimates`,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_ESTIMATE_PAGE} />
        ),
      },
      {
        path: `${ROOT}/admin/users`,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_USERS_PAGE} />
        ),
      },
      {
        path: `${ROOT}/admin/biddings`,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_BIDDING_PAGE} />
        ),
      },
      {
        path: [`${ROOT}/admin/bidding-details/:id`],
        exact: true,
        authenticated: true,
        component: (props) => (
          <RealTimeBidsContextProvider>
            <Page {...props} pageCode={PAGE_CODES.BIDDING_DETAILS} />
          </RealTimeBidsContextProvider>
        ),
      },
      {
        path: `${ROOT}/admin/listing-detail/:id/:tab`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.LISTING_UPDATE} />
        ),
      },
      {
        path: `${ROOT}/admin/sites`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.SITE_MANAGER} />
        ),
      },
      {
        path: `${ROOT}/admin/agreements`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.ADMIN_AGREEMENTS} />
        ),
      },
      {
        path: `${ROOT}/admin/estimate/:id`,
        exact: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.CASHRENT_ESTIMATE} />
        ),
      },
    ],
  },
  {
    path: `${ROOT}/my-account`,
    authenticated: true,
    component: SubMainLayoutHelper,
    routes: [
      {
        path: `${ROOT}/my-account/farms`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.DASHBOARD_FARMS} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/new`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_CREATE} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/overview`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_OVERVIEW} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/fields`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_FIELDS} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/fields/:fieldId`,
        exact: false,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FIELD_DETAIL} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/estimate`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_ESTIMATE} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/leases`,
        exact: true,
        authenticated: false,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_LEASES} />
        ),
      },
      {
        path: `${ROOT}/my-account/farms/:id/maps`,
        exact: true,
        authenticated: false,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.FARM_MAPS} />
        ),
      },
      {
        path: [
          `${ROOT}/my-account/listing/:status`,
          `${ROOT}/my-account/listing`,
        ],
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.DASHBOARD_LISTINGS} />
        ),
      },
      {
        path: `${ROOT}/my-account/farm-detail/:id`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.MY_LISTED_FARM} />
        ),
      },
      {
        path: [
          `${ROOT}/my-account/settings/:tab`,
          `${ROOT}/my-account/settings`,
        ],
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.DASHBOARD_SETTINGS} />
        ),
      },
      {
        path: [
          `${ROOT}/my-account/payments/:tab`,
          `${ROOT}/my-account/payments`,
        ],
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.DASHBOARD_PAYMENTS} />
        ),
      },
      {
        path: [`${ROOT}/my-account/bidding/:tab`, `${ROOT}/my-account/bidding`],
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.DASHBOARD_MY_BID} />
        ),
      },
      {
        path: [
          `${ROOT}/my-account/bidding-details/:id`,
          `${ROOT}/my-account/bidding-details/:id/:backTo`,
        ],
        exact: true,
        authenticated: true,
        component: (props) => (
          <RealTimeBidsContextProvider>
            <Page {...props} pageCode={PAGE_CODES.BIDDING_DETAILS} />
          </RealTimeBidsContextProvider>
        ),
      },
      {
        path: `${ROOT}/my-account/bidding-review-agreement/:id`,
        exact: true,
        authenticated: true,
        component: (props) => (
          <Page {...props} pageCode={PAGE_CODES.BIDDING_REVIEW_AGREEMENT} />
        ),
      },
    ],
  },
  {
    path: `${ROOT}/alliance-partners`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.ALLIANCE_PARTNERS} />
    ),
  },
  {
    path: `${ROOT}/blogs`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.BLOGS} />,
  },
  {
    path: `${ROOT}/blogs/:slug`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.BLOG_DETAIL} />,
  },
  {
    path: `${ROOT}/press`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.PRESS} />,
  },
  {
    path: `${ROOT}/farmer`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.FARMER} />,
  },
  {
    path: `${ROOT}/landowner`,
    exact: true,
    component: () => <Page pageCode={PAGE_CODES.LANDOWNER} />,
  },
  {
    path: `${ROOT}/contact-us`,
    exact: true,
    component: () => <Page pageCode={PAGE_CODES.CONTACT_US} />,
  },
  {
    path: `${ROOT}/about-us`,
    exact: true,
    component: () => <Page pageCode={PAGE_CODES.ABOUT_US} />,
  },
  {
    path: `${ROOT}/terms-and-conditions`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.TERMS_AND_CONDITIONS} />
    ),
  },
  {
    path: `${ROOT}/how-to-lease-farmland`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.HOW_TO_LEASE_LANDFARM} />
    ),
  },
  {
    path: `${ROOT}/find-farm-for-lease`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.FIND_FARM_FOR_LEASE} />
    ),
  },
  {
    path: `${ROOT}/find-farmer`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.FIND_A_FARMER} />
    ),
  },
  {
    path: `${ROOT}/illinois-farmland-for-rent`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.ILLINOIS_FARM_LAND_FOR_RENT} />
    ),
  },
  {
    path: `${ROOT}/iowa-farmland-for-rent`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.IOWA_FARM_LAND_FOR_RENT} />
    ),
  },
  {
    path: `${ROOT}/privacy-policy`,
    exact: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.PRIVATE_POLICY} />
    ),
  },
  {
    path: [
      `${ROOT}/land-detail/:id/:tab`,
      `${ROOT}/land-detail/:id`,
    ],
    authenticated: false,
    exact: true,
    component: (props) => (
      <RealTimeBidsContextProvider>
        <Page {...props} pageCode={PAGE_CODES.LAND_DETAIL} />
      </RealTimeBidsContextProvider>
    ),
  },
  {
    path: `${ROOT}/terms-conditions/:id`,
    exact: true,
    authenticated: false,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.LAND_TERMS} />
    ),
  },
  {
    path: `${ROOT}/sign-agreement-successful`,
    exact: true,
    authenticated: true,
    component: (props) => (
      <Page {...props} pageCode={PAGE_CODES.SUCCESS_AGREEMENT} />
    ),
  },
  {
    path: `${ROOT}/thank-you/:user_type`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.THANK_YOU} />,
  },
  {
    path: `${ROOT}/bidding/:id`,
    exact: true,
    component: (props) => (
      <RealTimeBidsContextProvider>
        <Page {...props} pageCode={PAGE_CODES.BIDDING_NEW} />
      </RealTimeBidsContextProvider>
    ),
  },
  {
    path: `${ROOT}/bidding/:id/sign`,
    exact: true,
    component: (props) => (
      <RealTimeBidsContextProvider>
        <Page {...props} pageCode={PAGE_CODES.BIDDING_GUEST_SIGN} />
      </RealTimeBidsContextProvider>
    ),
  },
  {
    path: `${ROOT}/login`,
    exact: true,
    component: (props) => <Page {...props} pageCode={PAGE_CODES.LOGIN} />,
  },
  {
    path: `${ROOT}/`,
    exact: true,
    component: (props) => (
      <Page
        {...props}
        pageCode={PAGE_CODES.HOME}
      />
    ),
  },
];
